import { Control, Controller } from "react-hook-form";
import InputField from "../../../../UIElements/InputField";

import { Grid } from "@mui/material";

type AdressFormProps = {
    control: Control<any>;
    errors: any;
    addressType: string;
    classes?: any;
};

const AddressForm = ({
    control,
    errors,
    addressType,
    classes,
}: AdressFormProps) => {
    return (
        <>
            <Controller
                name={`${addressType}.street`}
                control={control}
                render={({ field: { ref, ...others } }) => (
                    <InputField
                        label={"Adresse *"}
                        fullWidth
                        {...others}
                        outlinedinputsx={{
                            ...classes?.adressFormElements?.outlinedinputsx,
                        }}
                        errortext={errors[addressType]?.street?.message ?? ""}
                    />
                )}
            />

            <Controller
                name={`${addressType}.additionalDetails`}
                control={control}
                render={({ field: { ref, ...others } }) => (
                    <InputField
                        errortext={
                            errors[addressType]?.additionalDetails?.message ??
                            ""
                        }
                        outlinedinputsx={{
                            ...classes?.adressFormElements?.outlinedinputsx,
                        }}
                        {...others}
                        label={"Complément d’adresse"}
                        fullWidth
                    />
                )}
            />

            <Grid container spacing={1.5}>
                <Grid item xs={4}>
                    <Controller
                        name={`${addressType}.postalCode`}
                        control={control}
                        render={({ field: { ref, ...others } }) => (
                            <InputField
                                {...others}
                                label={"Code postale *"}
                                inputProps={{
                                    maxLength: "5",
                                }}
                                outlinedinputsx={{
                                    ...classes?.adressFormElements
                                        ?.outlinedinputsx,
                                }}
                                errortext={
                                    errors[addressType]?.postalCode?.message ??
                                    ""
                                }
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={8}>
                    <Controller
                        name={`${addressType}.city`}
                        control={control}
                        render={({ field: { ref, ...others } }) => (
                            <InputField
                                {...others}
                                label={"Ville *"}
                                outlinedinputsx={{
                                    ...classes?.adressFormElements
                                        ?.outlinedinputsx,
                                }}
                                errortext={
                                    errors[addressType]?.city?.message ?? ""
                                }
                            />
                        )}
                    />
                </Grid>
            </Grid>
        </>
    );
};

export default AddressForm;
